import { BeatLoader } from "react-spinners"
import { DownloadQueueItem, UploadFileType } from "./downloadQueue"
import Tippy from "@tippyjs/react"
import { ReactComponent as IconDone } from "assets/images/icons/icon-check-circle-success.svg"
import { ReactComponent as IconError } from "assets/images/icons/icon-remove-component-build.svg"
import PieChart from "components/Charts/Pie"
import React from "react"
import { isUndefined } from "lodash"
interface Props {
  queue: DownloadQueueItem
  index: number
  totalQueues: number
  callBack: (type: "delete", downloadId) => Promise<void>
  currentProgress: number
}
const isEqualProps = (prevProps: Props, nextProps: Props) => {
  return false
}

const ICON_SIZE = 30
const ICON_STYLE = { width: ICON_SIZE, height: ICON_SIZE }
export const ProcessItemCard = React.memo((props: Props) => {
  const { queue, index, totalQueues, callBack, currentProgress } = props
  const showError = queue.errorMessage
  const renderProcessIcon = (queue: DownloadQueueItem) => {
    if (queue.errorMessage) {
      return (
        <Tippy
          placement="bottom-end"
          content="Remove failed download"
          arrow={false}
          zIndex={999999999}
        >
          <div>
            <IconError
              onClick={() => {
                console.log("error icon clicked", queue.downloadId)
                callBack("delete", queue.downloadId)
              }}
            />
          </div>
        </Tippy>
      )
    }
    if (queue.done) {
      return <IconDone style={ICON_STYLE} />
    }
    return (
      <PieChart progress={currentProgress} size={ICON_SIZE} borderSize={6}>
        <p className="" />
      </PieChart>
    )
  }

  const renderTitle = (queue: DownloadQueueItem) => {
    if (isUndefined(queue.dataUploading)) {
      return (
        <p className="font-semibold text-[10px] text-[#56A012]">Download</p>
      )
    }
    let label = ""
    switch (queue.dataUploading.type as UploadFileType) {
      case UploadFileType.GERBER:
        label = "Gerber"
        break
      case UploadFileType.PCB_BOM:
      case UploadFileType.MECHANICAL_BOM:
      case UploadFileType.BOM:
        label = "BOM"
        break
      case UploadFileType.PCB_STACKUP:
        label = "Stackup"
        break
      case UploadFileType.PCB_ASSEMBLY:
        label = "Assembly"
        break
      case UploadFileType.OTHER_ATTACHMENT:
      case UploadFileType.MECHANICAL_ATTACHMENT:
      case UploadFileType.PCB_ATTACHMENT:
        label = "Attachment"
        break
      case UploadFileType.MECHANICAL_3D:
        label = "3D"
        break
    }
    return (
      <p className="font-semibold text-[10px] text-[#FDBE44]">{`Upload ${label}`}</p>
    )
  }
  return (
    <div
      key={queue.downloadId}
      className="flex flex-col justify-center min-h-[68px]"
      style={{
        borderBottom: index === totalQueues - 1 ? "none" : "1px solid #E4E4E4",
      }}
    >
      <div className="flex items-center justify-between">
        <div className="flex flex-col">
          <p className="text-[14px] leading-[24px] text-[#111111] truncate max-w-[250px]">
            {queue.name}
          </p>
          <div className="flex items-center">
            {renderTitle(queue)}
            <div className="min-w-[4px] h-[4px] rounded-full bg-[#7A7A7A] mx-2"></div>
            <p className="italic text-[10px] text-[#7A7A7A]">{queue.subName}</p>
          </div>
          {queue.processMessage && !queue.done && !queue.errorMessage ? (
            <div className="flex items-center">
              <BeatLoader color="#7A7A7A" loading={true} size={5} />
              <p className="italic text-[10px] text-[#7A7A7A] ml-[8px]">
                {queue.processMessage}
              </p>
            </div>
          ) : null}
        </div>

        <div className="flex items-center">{renderProcessIcon(queue)}</div>
      </div>

      {showError && (
        <p className="text-[12px] text-[#EA4545] mb-[8px]">
          {queue.errorMessage}
        </p>
      )}
    </div>
  )
}, isEqualProps)
